/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SiteNavItem_navigationModule$ref = any;
export type SiteNav_viewer$ref = any;
export type SiteNav_viewer = {
    readonly navigation?: {
        readonly modules: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly " $fragmentRefs": SiteNavItem_navigationModule$ref;
        } | null> | null;
    } | null;
    readonly tradeNavigation?: {
        readonly modules: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly " $fragmentRefs": SiteNavItem_navigationModule$ref;
        } | null> | null;
    } | null;
    readonly " $refType": SiteNav_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "rootId",
        "variableName": "previewKey"
    } as any), v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "modules",
            "storageKey": null,
            "args": null,
            "concreteType": "NavigationModule",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serviceId",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SiteNavItem_navigationModule",
                    "args": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "SiteNav_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "previewKey",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "fetchNav",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "fetchTradeNav",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchNav",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "navigation",
                        "name": "navigation",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/)
                        ],
                        "concreteType": "Navigation",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchTradeNav",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "tradeNavigation",
                        "name": "navigation",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "userType",
                                "value": "TRADE"
                            }
                        ],
                        "concreteType": "Navigation",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '67f862a1d5c0841169217f3a351d0070';
export default node;
